import {
  MobileDateTimePicker,
  type MobileDateTimePickerProps,
} from '@mui/x-date-pickers/MobileDateTimePicker';

import { renderHourMinuteDigitalClock } from 'src/common/components/form/HourMinuteDigitalClock';

const timeViewRenderers = {
  hours: renderHourMinuteDigitalClock,
  minutes: renderHourMinuteDigitalClock,
  seconds: renderHourMinuteDigitalClock,
};

/**
 * App datetime picker. Replaces MUI's digital clock columns, which snap scroll
 * back to the selected value and block hour/minute selection.
 */
export default function AppDateTimePicker(props: MobileDateTimePickerProps) {
  return (
    <MobileDateTimePicker
      ampm={false}
      timeSteps={{ minutes: 1 }}
      {...props}
      viewRenderers={{
        ...timeViewRenderers,
        ...props.viewRenderers,
      }}
    />
  );
}
